module.exports = __webpack_public_path__ + "video/400_KBSAT30_2022_SERFIntro.01499acd.vtt";